export default "__VITE_ASSET__Ccxii89j__"